import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import setting4Icon from 'assets/images/icons/setting-4.svg';
import infoCircleGreyIcon from 'assets/images/icons/info-circle.svg';
import linkGreenIcon from 'assets/images/icons/link-green.svg';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import { DEFAULT_NUMBER_OF_COLUMNS, FONT_FAMILY_MAP } from '../utils';

const ChartEditHeader = ({ widget, handleAction, currentWidgetsRows }) => {
  const { basicProps, advancedProps } = widget;
  const captionFontFamily = FONT_FAMILY_MAP[advancedProps.captionFontWeight] || '';
  const options = [
    { value: 'move-up', displayValue: 'select_move_to_up', disabled: widget.startRow === 1 },
    {
      value: 'move-down',
      displayValue: 'select_move_to_down',
      disabled: widget.startRow + widget.takeRows >= currentWidgetsRows,
    },
    { value: 'move-left', displayValue: 'select_move_to_left', disabled: widget.startColumn === 1 },
    {
      value: 'move-right',
      displayValue: 'select_move_to_right',
      disabled: widget.startColumn + widget.takeColumns === DEFAULT_NUMBER_OF_COLUMNS,
    },
    { value: 'duplicate', displayValue: 'select_duplicate' },
    { value: 'delete', displayValue: 'select_delete' },
  ];

  return (
    <div className='widget-edit-header'>
      <div className='d-flex align-items-center gap-2'>
        {!['imageCard'].includes(basicProps.chartType) && (
          <Fragment>
            {basicProps.caption && (
              <span
                style={{ fontSize: advancedProps.captionFontSize, fontFamily: captionFontFamily }}
              >
                {basicProps.caption}
              </span>
            )}
            {advancedProps.tooltip && <img src={infoCircleGreyIcon} />}
            {advancedProps.linkedPageId && <img className='cursor-pointer' src={linkGreenIcon} />}
          </Fragment>
        )}
      </div>
      <div className='d-flex gap-2 align-items-center'>
        <img
          src={setting4Icon}
          className='cursor-pointer mt-1'
          onClick={() => handleAction('edit', widget._id)}
        />

        <MultiLevelSelect
          options={{ children: options, selectMultiple: false, searchable: false }}
          value={[]}
          name='action'
          handleChange={(_, value) => handleAction(value[0], widget._id)}
          toggleClasses='px-1'
          toggleComponent={<img src={dotsIcon} className='cursor-pointer' />}
        />
      </div>
    </div>
  );
};

ChartEditHeader.propTypes = {
  widget: PropTypes.object.isRequired,
  currentWidgetsRows: PropTypes.number.isRequired,
  handleAction: PropTypes.func.isRequired,
};

export default ChartEditHeader;
